// import { Component, OnInit } from '@angular/core';
import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MappingToolService } from '../../services/mapping-tool/mapping-tool.service';
// import { MatStepper, MatAutocompleteTrigger } from '@angular/material';
import {MatAutocompleteTrigger} from '@angular/material/autocomplete';
import { MatStepper } from '@angular/material/stepper';

import { NgxSpinnerService } from 'ngx-spinner';
import { LoginService} from '../../services/login.service';
import { startWith, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import * as _ from 'underscore';
import * as jwt_decode from "jwt-decode";

export interface Form {
	name: string;
	number: string;
	geoCode: string;
}

@Component({
	selector: 'app-fuse-flow',
  templateUrl: './fuse-flow.component.html',
  styleUrls: ['./fuse-flow.component.scss'],
	encapsulation: ViewEncapsulation.None
})

export class FuseFlowComponent implements OnInit {
	[x: string]: any;

	dashboard;
	public loggedInUserId;
	@BlockUI() blockUI: NgBlockUI;
	@ViewChild(MatAutocompleteTrigger, { read: MatAutocompleteTrigger })
	autoCompleteInput: MatAutocompleteTrigger;
	dragSource = null;
	dropTarget = null;

	widgets;
	firstFormGroup: FormGroup;
	myControl = new FormControl();
	options: any[] = [];
	outputFormat: any[];
	filteredOptions: Observable<Form[]>;

	form_geoCode: string;
	pdfData: any;
	pdfSrc: any;
	addressSplit: boolean = false;
	showDownloadMsg: boolean;
	loading: boolean;
	inpFormat: string;
	outFormat: string;
	requestData: any = {
		form: '',
		inpFormat: 'PDF',
		outFormat: 'ELABEL',
		addressSplit: false,
		responseType: null,
		formSource: null
	}
	pdfRequestData: string;
	fileName: string;
	submitted: boolean;
	xmlData: any;
	formNumber: any;
	acordForm: any;
	geoCode: any;
	isCustomForm: boolean = false;
	userData: any;
	pdfError: boolean = false;
	errorMessage: any;
	formSource: any;
	fileUpload: any;
	fileExtnError: boolean = false;
	noFileSelected: boolean = false;
	closeRequest: boolean = false;
	downloadFormtErr: boolean = false;
	formNoRequired: boolean = false;
	formNumberVal: any = null;
	formAvailable: boolean = true;

  	formId: any;
  	docType: any;
	errorExists: any;

	constructor(
		private fb: FormBuilder,
		public mappingToolService: MappingToolService,
		private loginService: LoginService,
		private spinner: NgxSpinnerService,
		private ref: ChangeDetectorRef
	) {

	}

	ngOnInit() {
		window.addEventListener('scroll', this.scrollEvent.bind(this), true);
    	this.docType = 'pdf';
		this.userData = jwt_decode(localStorage.getItem('AuthorizationD')).userPayload;

		//this.loggedInUserId  = (JSON.parse(localStorage.getItem('loggedInUser')))? JSON.parse(localStorage.getItem('loggedInUser')).userId : undefined;
		this.firstFormGroup = this.fb.group({
      		formNumber: [''],
			//formNumber: ['', Validators.required],
			fileToUpload: ['', Validators.required],
			addressSplit: [''],
			// acordForm: ['', Validators.required],
			// uploadFormat: ['', Validators.required],
			receiverCode: [''],
			senderCode: ['']
		});

		this.outputFormat = [
			{
				label: 'XML',
				value: 'XML'
			},
			{
				label: 'JSON',
				value: 'JSON'
			},
			{
				label: 'CSV',
				value: 'CSV'
			}
		]

		this.mappingToolService.getNonAcordForms().subscribe((resp: any) => {
			// this.options = _.sortBy(this.removeDuplicates(resp, 'number'), 'number');

			let uniqueData = this.removeDuplicates(resp, 'number');
			this.options = _.sortBy(uniqueData, (o) => {
				return parseInt(o.number);
			});

			this.filteredOptions = this.myControl.valueChanges
				.pipe(
					startWith(''),
					map((value: string) => {
						const filterdata = this._filter(value);
						return filterdata;
					})
				);
		});

	};

	scrollEvent(event) {
		if (!event.target.id.includes("autocomplete")) {
			if (this.autoCompleteInput && this.autoCompleteInput.panelOpen) {
				this.autoCompleteInput.closePanel();
			}
		}
	};

	get f() { return this.firstFormGroup.controls; }

	public removeDuplicates(arr, prop) {
		return arr.filter((obj, pos, arr) => {
			return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
		});
	}

	private _filter(value: string): any[] {
		if (value == null) {
			return;
		}
		const filterValue = value; //.toLowerCase();
		return this.options.filter(option => (option.number != null && option.number.indexOf(filterValue) > -1));
	}

	openFile(event) {
		let input = event.target;
		let reader1 = new FileReader();
		let reader2 = new FileReader();
		this.fileName = event.srcElement && event.srcElement.files && event.srcElement.files[0] && event.srcElement.files[0].name;
		if (this.fileName) {
			this.noFileSelected = false;
		} else {
			this.noFileSelected = true;
		}
		var extn = this.fileName.split(".").pop();

		if (extn.toLowerCase() != 'pdf' && extn.toLowerCase() != 'xls' && extn.toLowerCase() != 'xlsx') {
			this.fileExtnError = true;
		} else {
			this.fileExtnError = false;
		}

		reader1.onload = () => {
			this.pdfSrc = reader1.result;
		}
		reader1.readAsArrayBuffer(input.files[0]);

		reader2.onload = () => {
			this.pdfData = reader2.result;
		}
		reader2.readAsText(input.files[0]);
	}

	changeUploadFormat(event) {
		this.firstFormGroup.controls['uploadFormat'].setValue(event.value);
		// this.downloadFormtErr = false;
		this.outFormat = event.value;
	}

	_arrayBufferToBase64(buffer) {
		var binary = '';
		var bytes = new Uint8Array(buffer);
		var len = bytes.byteLength;
		for (var i = 0; i < len; i++) {
			binary += String.fromCharCode(bytes[i]);
		}
		return window.btoa(binary);
	}

	selectForm(event) {
		this.myControl.setValue(event.option.value.number.replace('_', ' '));
		this.firstFormGroup.controls['formNumber'].setValue(event.option.value.number);
		this.formSource = event.option.value.source;
		this.formNumber = event.option.value.number;
		this.geoCode = event.option.value.geoCode;
		this.formNumberVal = event.option.value.number;
    this.formNoRequired = false;

    this.formId = event.option.value.id;

    if(event.option.value.docType)
      this.docType = event.option.value.docType;

		this.checkForm();
	}

	checkForm() {
		if(this.formNumberVal) {
			this.formNoRequired = false;
		}
		const filterValue = this.formNumberVal; //.toLowerCase();

		var isForm = this.options.filter(option => option.number == filterValue).length;
		if (isForm) {
			this.formAvailable = true;
		} else {
			this.formAvailable = false;
		}
	}

	MoveNext(stepper: MatStepper) {
		this.submitted = true;
		this.requestData.form = null;
		this.requestData.responseType = this.firstFormGroup.value.uploadFormat;
		this.requestData.addressSplit = this.firstFormGroup.value.addressSplit;
		this.errorExists = 0;
			if (!this.formAvailable) {
				this.loading = false;
				//this.firstFormGroup.get('formNumber').setValidators([Validators.required]);
				this.firstFormGroup.get('formNumber').setErrors({required: true});
				this.errorExists = 1;
			}
			if (this.formNumberVal == null || this.formNumberVal == undefined) {
				this.loading = false;
				this.formNoRequired = true;
				this.firstFormGroup.get('formNumber').setErrors({required: true});
        		this.errorExists = 1
			}	else {
				this.requestData.formSource = this.formSource;
				this.requestData.form = this.formNumberVal;
			}
			this.outFormat = 'CSV';
		if (this.outFormat == null || this.outFormat == undefined) {
			this.loading = false;
			// return;
			// this.firstFormGroup.controls['uploadFormat'].setErrors({required: true});
			this.errorExists = 1;
		}

		if ((this.pdfData == '') || (this.pdfData == undefined) || (this.fileName == null) || this.fileExtnError) {
			this.noFileSelected = true;
			this.loading = false;
			this.firstFormGroup.controls['fileToUpload'].setErrors({required: true});
			this.errorExists = 1;
		} else {
			this.noFileSelected = false;
		}
		if(this.errorExists == 0) {
			if (this.docType === "pdf" || this.docType === "excel") {
				this.getOutputFile(stepper);
			}
		}
  }
	getOutputFile(stepper: MatStepper) {
		this.pdfData = this._arrayBufferToBase64(this.pdfSrc);
		this.spinner.show();
		this.pdfError = false;
		this.closeRequest = true;
		this.requestData.formId = this.formId;
		this.showDownloadMsg = false;
		// this.loginService.getOutputFile(this.requestData, this.pdfData, this.userData, this.isCustomForm, this.docType, this.firstFormGroup.get('senderCode').value, this.firstFormGroup.get('receiverCode').value).then(resp => {}).catch(resp => {}),()=> {})
		this.loginService.getOutputFile(this.requestData, this.pdfData, this.userData, this.isCustomForm, this.docType, this.firstFormGroup.get('senderCode').value, this.firstFormGroup.get('receiverCode').value).then(
			(response: any) => {
				this.spinner.hide();
				this.xmlData = response;
				if(this.xmlData == "Server is temporary down. Please try again after sometime!") {
					this.xmlData = '';
				}
				if((this.xmlData.length > 10000) || (this.xmlData == '')) {
					this.showDownloadMsg = true;
				}
				stepper.next();
			}).catch(error => {
				this.pdfError = true;
				if (error && error.status == 500) {
					this.errorMessage = error && error.message;
				} else {
					this.errorMessage = error && error.error;
				}
				stepper.next();
				this.loading = false;
				this.spinner.hide();
			})
	}

	closeLoading() {
		this.loading = false;
		this.spinner.hide();
		this.closeRequest = false;
		location.reload();
	}

	resetForm() {
		this.firstFormGroup = this.fb.group({
			formNumber: [''],
			fileToUpload: [''],
			addressSplit: [''],
			uploadFormat: [''],
			senderCode: [''],
			receiverCode: ['']
		});
		this.fileName = null;
		this.formAvailable = true;
		this.firstFormGroup.controls['formNumber'].setErrors(null);
		this.firstFormGroup.controls['fileToUpload'].setErrors(null);
		this.firstFormGroup.controls['uploadFormat'].setErrors(null);
		this.formNumber = null;
		this.formNumberVal = null;
		this.pdfSrc = null;
		this.pdfData = null;
		this.noFileSelected = false;
		this.outFormat = null;
		this.formNoRequired = false;
		this.downloadFormtErr = false;
	}

	Download() {
		this.loginService.getDocument().then(resp => {
			if(resp) {
				let file = 'data:application/xml,' + encodeURIComponent(resp);
				const downloadLink = document.createElement("a");
				downloadLink.href = file;
				downloadLink.download = 'Output.xml';
				downloadLink.click();
			}
		});
	}
}
